module.exports = __webpack_public_path__ + "static/media/user.5c65b232.jpg";